export default "__VITE_ASSET__ByiVpx8h__"